import { z } from 'zod';

import { CollectionStatus, CollectionType } from '@/models/appointment/Appointment.ts';

// Only the fields the booking-success hooks actually read (sorting by `start`,
// rendering `id`/`start`/`end` in the success notification and summary entries).
export const preBookedAppointmentSchema = z.object({
    id: z.string(),
    start: z.string(),
    end: z.string(),
});

export type PreBookedCollectionAppointment = z.infer<typeof preBookedAppointmentSchema>;

export const bookAppointmentCollectionResponseSchema = z.object({
    collection: z
        .object({
            id: z.string(),
            type: z.enum(CollectionType),
            booking_status: z.enum([CollectionStatus.SUCCESS, CollectionStatus.FAILED]),
            meta: z.object({
                created_at: z.iso.datetime(),
                updated_at: z.iso.datetime(),
            }),
        })
        .loose(),
    pre_booked_appointments: z.array(preBookedAppointmentSchema),
});
